import { AUTH_USER, UNAUTH_USER } from "actions";

// `status` is deliberately three-valued. Before onAuthStateChanged has
// reported for the first time we do not yet know whether there is a session,
// and that "unknown" state must not be treated as signed out — otherwise a
// signed-in user is bounced to the sign-in page on every page load.
export const INITIAL_STATE = { status: "unknown", user: {} };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_USER:
      return { status: "authed", user: action.payload || {} };
    case UNAUTH_USER:
      return { status: "unauthed", user: {} };
    default:
      return state;
  }
}
